import { Injectable } from '@angular/core';
import { CompanyAccount } from '@app/shared/models/company-account.model';
import { AuthenticatedUser } from '@app/shared/models/authenticated-user.model';
import { Adapter } from '../adapter';
import { COMPANY_TYPE } from '@app/shared/models/company-type';
import { CompanyAccountAdapter } from './company-account.adapter';

@Injectable()
export class AuthenticatedUserAdapter implements Adapter<AuthenticatedUser> {
    constructor(private companyAccountAdapter: CompanyAccountAdapter) {}

    adapt(data: any): AuthenticatedUser {
        const accounts: CompanyAccount[] = data.roles
            ? data.roles.map((role: any) =>
                  this.companyAccountAdapter.adapt({
                      ...role,
                      rawValue: JSON.stringify(role),
                  })
              )
            : [];

        return {
            id: data.userId || 0,
            name: data.userName || '',
            domain:
                accounts.map((account) => account.domain).find((_item, index) => index === 0) || '',
            serviceAccount: accounts.find((account) => account.type === COMPANY_TYPE.service),
            childAccounts: accounts.filter((account) => account.type !== COMPANY_TYPE.service),
        } as AuthenticatedUser;
    }
}
